<template>
  <div class="py-5" style="max-width: 700px; margin: auto;">
    <b-card>
      <list-view
        v-if="reports.length > 0"
        :items="reports"
        @delete="handleDelete"
        @edit="handleEdit"/>

      <empty-view
        v-else
        @create="handleCreate"/>

      <confirm-delete
        v-if="deleteID"
        :key="deleteID"
        :id="deleteID"
        @close="deleteID = null"/>

      <editor
        v-if="editSessionID"
        :key="editSessionID"
        :id="editID"
        @close="editSessionID = null"/>
    </b-card>

    <div class="mt-3 text-center" v-if="reports.length > 0">
      <b-button size="lg" variant="primary" @click="handleCreate">
        <i class="fa fa-plus mr-2"/>
        Add Custom Report
      </b-button>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash';
  import ListView from './ListView';
  import EmptyView from './EmptyView';
  import ConfirmDelete from './ConfirmDelete';
  import Editor from './Editor';

  export default {
    name: 'CustomReportsManager',

    components: {ListView, EmptyView, ConfirmDelete, Editor},

    data() {
      return {
        deleteID: null,
        editID: null,
        editSessionID: null,
      };
    },

    computed: {
      reports() {
        const reports = Object.values(this.$store.state.customReports.items);
        return _.sortBy(reports, ({createdAt}) => new Date(createdAt));
      },
    },

    methods: {
      handleDelete(reportID) {
        this.deleteID = reportID;
      },

      handleEdit(id = null) {
        this.editID = id;
        this.editSessionID = (new Date()).getMilliseconds();
      },

      handleCreate() {
        this.handleEdit();
      }
    }
  };
</script>

<style scoped>

</style>
